<div class="w-100 overflow-hidden maine-container" *ngIf="!loading">
  <div class="row g-2 mb-2 rounded-3">
    <div class="col d-flex" style="padding-right: 0 !important">
      <div class="highlights common-padding border bg-white flex-grow-1 left-border-radious ">
        <header class="section-header">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="text-dark fw-bold all_summary_text">
              {{ "HUDDLE_HIGHLIGHTS" | translate }}
            </h6>
          </div>
          <p class="mb-0 opacity-50 all_summary_text">
            {{ "HIGHLIGHTS_CARD_SUBTEXT" | translate }}
          </p>
        </header>
        <section class="highlight-box">
          <div class="row">
            <div class="col d-flex align-items-center" *ngIf="!loading">
              <div class="huddle_total">
                <!-- <span class="fw-bold ps-2 huddle_digits">{{ totalMeeting}}</span> -->
                <!-- <app-ltms-loader></app-ltms-loader> -->
                <span class="fw-bold ps-2 huddle_digits">{{ getTotalHuddleCount() | number }}</span>
                <p class="opacity-75 ps-2 all_summary_text">{{ "TOTAL_HUDDLES" | translate }}</p>
              </div>
            </div>
            <!-- <div class="col"></div>
            <div class="col"></div> -->
          </div>
          <div class="spotlight-feed">
            <div class="col d-flex justify-content-center align-items-center ">
              <div>
                <span class="fw-bold huddle_digits">{{ spotlightTotalFeeds | number }}</span>
                <p class="opacity-75 all_summary_text">{{"HUDDLE_SPOTLIGHTS" | translate}}</p>
              </div>
            </div>
            <div class="col d-flex justify-content-center align-items-center border-end border-start">
              <div>
                <span class="fw-bold huddle_digits">{{ actionTotalFeeds | number }}</span>
                <p class="opacity-75 all_summary_text">{{"HUDDLE_ACTION_PLAN"|translate}}</p>
              </div>
            </div>
            <div class="col d-flex justify-content-center align-items-center">
              <div>
                <span class="fw-bold huddle_digits">{{ suggTotalFeeds | number }}</span>
                <p class="opacity-75 all_summary_text">{{"HUDDLE_SUGGESTION"| translate}}</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>

    <div class="col d-flex p-0">
      <div class="common-padding border d-flex flex-column bg-white flex-grow-1">
        <header class="section-header">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="text-dark fw-bold all_summary_text">
              {{ "HUDDLE_ACTION_PLAN" | translate }}
            </h6>
          </div>
          <p class="mb-0 opacity-50 all_summary_text">
            {{ "ACTION_PLANS_CARD_SUBTEXT" | translate }}
          </p>
        </header>
        <section class="doughnut-container">
          <div class="align-self-center">
            <app-ltms-doughnut-chart-view [chartData]="actionDonutData" elementId="legend-container-1"
              [colors]="actionDonutColors"></app-ltms-doughnut-chart-view>
          </div>
          <div class="d-flex align-items-center">
            <div>
              <div *ngFor="let label of actionDonutData; let i = index" class="d-flex">
                <span class="doughnut-dot" [ngStyle]="{'background-color':getDotColor(actionDonutColors, i)}"></span>
                <div class="d-flex flex-column">
                  <span class="doughnut-label">{{label.key}}</span>
                  <strong class="doughnut-value">{{label.value}}</strong>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>


    <div class="col d-flex" style="padding-left: 0 !important">
      <div class="border bg-white common-padding d-flex flex-column flex-grow-1 right-border-radious">
        <header class="section-header">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="text-dark fw-bold all_summary_text">
              {{ "HUDDLE_SUGGESTIONS" | translate }}
            </h6>
          </div>
          <p class="mb-0 opacity-50 all_summary_text">
            {{ "SUGGESTIONS_CARD_SUBTEXT" | translate }}
          </p>
        </header>
        <section class="doughnut-container">
          <div class="align-self-center">
            <app-ltms-doughnut-chart-view [chartData]="suggDonutData" elementId="legend-container-2"
              [colors]="suggDonutColors"></app-ltms-doughnut-chart-view>
          </div>
          <div class="d-flex align-items-center">
            <div>
              <div class="d-flex" *ngFor="let label of suggDonutData; let i = index">
                <span class="doughnut-dot" [ngStyle]="{'background-color':getDotColor(suggDonutColors, i)}"></span>
                <div class="d-flex flex-column">
                  <span class="doughnut-label">{{label.key}}</span>
                  <strong class="doughnut-value">{{label.value}}</strong>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>

  <!-- Top themes -->
  <div class="card-container mb-2">
    <div class="card-wrapper" *ngFor="let card of cards; let i=index">
      <div class="card border rounded bg-white common-padding">
        <header class="section-header">
          <div class="d-flex justify-content-between ">
            <h6 class="text-dark fw-bold mb-0 all_summary_text">{{ card?.heading }}</h6>
            <div class="d-flex align-items-center">
              <span class="px-2 fw-bold all_summary_text">{{ "HUDDLE_VIEW_BY" | translate }}</span>
              <div class="button-container">
                <div class="dropdown" [ngClass]="{'show': isDropdownOpen[i]}">
                  <button class="btn btn-light all_summary_text dropdown-toggle" (click)="toggleDropdown(i)"
                    aria-expanded="false">
                    Themes
                  </button>
                  <div class="dropdown-menu" [ngClass]="{'show': isDropdownOpen[i]}">
                    <a class="dropdown-item" (click)="selectItem(i)">Themes</a>
                  </div>
                </div>
                <div class="btn-group toggle-group">
                  <!-- Graph View Button -->
                  <button class="btn btn-toggle" [class.active]="viewModes[i] === 'progress'"
                    (click)="toggleView('progress', i)" placement="bottom" ngbTooltip="Graph View"
                    tooltipClass="custom-tooltip-background" container="body" triggers="mouseenter:mouseleave">
                    <img
                      [src]="viewModes[i] === 'progress' ? 'assets/images/view-graph.svg' : 'assets/images/view-graph-active.svg'"
                      alt="Graph View" />
                  </button>
                  <div class="divider"></div>
                  <button class="btn btn-toggle" [class.active]="viewModes[i] === 'table'"
                    (click)="toggleView('table', i)" placement="bottom" ngbTooltip="Table View"
                    tooltipClass="custom-tooltip-background" container="body" triggers="mouseenter:mouseleave">
                    <img
                      [src]="viewModes[i] === 'table' ? 'assets/images/view-list-active.svg' : 'assets/images/view-list.svg'"
                      alt="List View" />
                  </button>

                </div>
              </div>
            </div>
          </div>
          <p class="mb-0 opacity-75 all_summary_text w-60">
            {{ card?.subHeading }}
          </p>
        </header>

        <div *ngIf="viewModes[i] === 'progress'">
          <section class="d-flex flex-column">
            <div class="row flex-grow-1" *ngFor="let data of card?.data">
              <div class="col-5  all_summary_text">{{ data?.title }}</div>
              <div class="col-2 ">{{ data?.unit }}</div>
              <div class="col-5">
                <app-progress-bar [value]="data.progressBar"></app-progress-bar>
              </div>
            </div>
          </section>

          <footer class="d-flex justify-content-center mt-2">
            <ul class="list-inline custom-list d-flex justify-content-center flex-wrap gap-2">
              <li class="list-inline-item" *ngFor="let dot of getDotsForCard(card)"
                [ngStyle]="{ '--bullet-color': dot.color }">
                {{ dot.title }}
              </li>
            </ul>
          </footer>
        </div>

        <div class="card-table" *ngIf="viewModes[i] === 'table'">
          <app-score-table [tableColumns]="columns[i]" [tableData]="card.data"></app-score-table>
        </div>
      </div>
    </div>
  </div>

  <!-- Spotlight Cards -->
  <div class="border rounded bg-white common-padding mb-2">
    <div>
      <div class="section-header">
        <div class="d-flex justify-content-between align-items-center">
          <h6 class="text-dark fw-bold mb-0 all_summary_text">
            {{ "HUDDLE_SPOTLIGHTS" | translate }}
          </h6>
          <button class="text-dark text-decoration-none all_summary_text bg-transparent border-0"
            (click)="tabChangeHandler(tabType.ALL_SPOTLIGHTS)">{{"HUDDLE_VIEW_ALL_SPOTIGHT_BUTTON"| translate}}</button>
        </div>

        <p class="mb-0 opacity-75 all_summary_text">
          {{ "SPOTLIGHTS_CARD_TEXT" | translate }}.
        </p>
      </div>
    </div>
    <div *ngIf="!spotlightData || spotlightData.length === 0"
      class="text-center text-muted my-3 d-flex align-items-center justify-content-center all_summary_text"
      style="min-height: 150px;">
      No data available for selected filters.
    </div>
    <div class="row g-3 align-items-start" *ngIf="spotlightData && spotlightData.length > 0">
      <!-- <div class="col-12 col-md-6 col-lg-3 d-flex" *ngFor="let spotlight of spotlightData?.slice(0, 8)">
        <div class="custom-card d-flex flex-column p-3 w-100">
          <div class="trophy_container">
            <img src="assets/images/trophy-outline.svg" alt="Trophy" class="trophy_icon" />
            <span class="trophy_count">{{ spotlight.count }}</span>
          </div>
          <h6 class="text-dark  my-1 all_summary_text">{{ spotlight.customerName }}</h6>
          <h6 class="text-muted  my-2 all_summary_text">{{ spotlight.meetingName }}</h6>
          <p class="card-text text-dark  mb-0 flex-grow-1 text-truncate all_summary_text spotlight-comments"
            [attr.data-bs-toggle]="'tooltip'" [attr.data-bs-placement]="'top'" [attr.title]="spotlight.comments">
            {{ spotlight.comments }}
          </p>
        </div>
      </div> -->
     
      <div class="huddle-spotlight-card" *ngFor="let spotlight of spotlightData?.slice(0, 8)">
        <div class="trophy_container">
          <img src="assets/images/trophy-outline.svg" alt="Trophy" class="trophy_icon" />
          <span class="trophy_count">{{ spotlight.count }}</span>
        </div>
        <div class="huddle-spotlight-card-body">
          <div class="huddle-spotlight-username">
            {{ spotlight.customerName }}
          </div>
          <div class="huddle-spotlight-meetingname">
            {{ spotlight.meetingName }}
          </div>
          <div class="huddle-spotlight-card-text">
            <div class="ellipsed-text"
            #commentText
            [class.show-more]="spotlight.showMore">
         {{ spotlight.comments }}
       </div>
       <div class="show-more-btn-wrappar" *ngIf="spotlight.ellipsisActive || spotlight.showMore">
        <button class="show-more-btn" (click)="changeCardView($event, spotlight)">
          {{ spotlight.showMore ? '[Collapse]' : '[More...]' }}
        </button>
      </div>
          </div>
        </div>
      </div>
      </div>
  </div>
  <!-- <div class="border top-border-radious bg-white common-padding mb-2">
    <div class="d-flex justify-content-between align-items-center">
      <h6 class="text-dark fw-bold mb-0 all_summary_text">
        {{ "HUDDLE_CURRENTLY_ACTIVE" | translate }}
      </h6>
    </div>
    <p class="mb-0 opacity-75 all_summary_text">
      {{ "HUDDLE_CARD_SUBTEXT" | translate }}.
    </p>
  </div> -->
  <!-- Action Plans Card -->
  <div class="row g-2 mb-2">
    <div class="col">
      <div class="border bottom-border-radious bg-white">
        <div>
          <div class="suggestion-header">
            <div class="d-flex justify-content-between align-items-center">
              <h6 class="text-dark fw-bold mb-0 all_summary_text">
                {{ "Action Plans" }}
              </h6>
              <button class="text-dark text-decoration-none all_summary_text bg-transparent border-0"
                (click)="tabChangeHandler(tabType.ALL_ACTION_PLANS)">{{"HUDDLE_VIEW_ALL"| translate}}</button>
            </div>

            <p class="mb-0 opacity-75 all_summary_text">
              {{ "ACTION_PLANS_CARD_TEXT" | translate }}.
            </p>
          </div>
          <div class="suggestion-table">
            <table class="table w-100">
              <thead class="card-thead">
                <tr class="table-header">
                  <th class="problem-statement_text">
                    {{ "Problem Statement" }}
                  </th>
                  <th class="summary_table_header all_summary_text">
                    {{ "Theme" }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="!actionPlanData?.data || actionPlanData?.data.length === 0">
                  <td colspan="2" class="text-center text-muted py-5 all_summary_text">
                    No data available for selected filters.
                  </td>
                </tr>
                <tr *ngFor="let data of actionPlanData?.data; let i = index" class="px-0 py-2">
                  <!-- Problem Statement -->
                  <td class="text-dark px-0 all_summary_text problem-statement">
                    <div class="d-flex flex-column align-items-start">
                      <div #actionProblemText
                           class="suggestion-content"
                           [ngClass]="{ 'expanded': data.isActionProblemExpanded }">
                        {{
                          data["litmus_processed_data"]["tag_ltms_huddle_1a839c1a-f09f-4344-8a82-7974f716b0e9"]
                        }}
                      </div>
                      <button class="read-more-btn"
                              *ngIf="data.actionProblemEllipsisActive || data.isActionProblemExpanded"
                              (click)="toggleExpandAction(data, 'problem')">
                        {{ data.isActionProblemExpanded ? '[Collapse]' : '[More...]' }}
                      </button>
                    </div>
                  </td>
                
                  <!-- Theme -->
                  <td class="text-dark px-0 summary_table_row">
                    <div class="d-flex flex-column align-items-start">
                      <div #actionThemeText
                           class="suggestion-content summary_table_row"
                           [ngClass]="{ 'expanded': data.isActionThemeExpanded }">
                        {{
                          data["litmus_processed_data"]["tag_ltms_huddle_theme_display_name"]
                        }}
                      </div>
                      <button class="read-more-btn"
                              *ngIf="data.actionThemeEllipsisActive || data.isActionThemeExpanded"
                              (click)="toggleExpandAction(data, 'theme')">
                        {{ data.isActionThemeExpanded ? '[Collapse]' : '[More...]' }}
                      </button>
                    </div>
                  </td>
                </tr>
                
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- Suggestions Card -->
    <div class="col">
      <div class="border bottom-border-radious bg-white">
        <div>
          <div class="suggestion-header">
            <div class="d-flex justify-content-between align-items-center">
              <h6 class="text-dark fw-bold mb-0 all_summary_text">
                {{ "Suggestions" }}
              </h6>
              <button class="text-dark text-decoration-none all_summary_text bg-transparent border-0"
                (click)="tabChangeHandler(tabType.ALL_SUGGESTIONS)">{{"HUDDLE_VIEW_ALL" | translate}}</button>
            </div>

            <p class="mb-0 opacity-75 all_summary_text">
              {{ "SUGGESTIONS_CARD_TEXT" | translate }}.
            </p>
          </div>
          <div class="suggestion-table">
            <table class="table">
              <thead class="card-thead">
                <tr class="table-header">
                  <th class="problem-statement_text" >
                    {{ "Problem Statement" }}
                  </th>
                  <th class="summary_table_header all_summary_text">{{
                    "Recommendations/Suggestions" }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="!actionPlanData?.data || actionPlanData?.data.length === 0">
                  <td colspan="2" class="text-center text-muted py-5 all_summary_text">
                    No data available for selected filters.
                  </td>
                </tr>
                <tr *ngFor="let data of suggestionData?.data; let i = index">
                  <!-- Problem Statement -->
                  <td class="text-dark px-0 all_summary_text problem-statement">
                    <div class="d-flex flex-column align-items-start">
                      <div #problemText
                           class="suggestion-content"
                           [ngClass]="{'expanded': data.isProblemExpanded}">
                        {{
                          data["litmus_processed_data"]["tag_ltms_huddle_suggestions_for_process_imporvement_item_description_1"]
                        }}
                      </div>
                      <button class="read-more-btn"
                              *ngIf="data.problemEllipsisActive || data.isProblemExpanded"
                              (click)="toggleExpand(data, 'problem')">
                        {{ data.isProblemExpanded ? '[Collapse]' : '[More...]' }}
                      </button>
                    </div>
                  </td>
                
                  <!-- Recommendation/Suggestion -->
                  <td class="text-dark px-0 all_summary_text problem-statement">
                    <div class="d-flex flex-column align-items-start">
                      <div #recommendationText
                           class="suggestion-content summary_table_row"
                           [ngClass]="{'expanded': data.isRecommendationExpanded}">
                        {{
                          data["litmus_processed_data"]["tag_ltms_huddle_suggestions_for_process_imporvement_recommendation_1"]
                        }}
                      </div>
                      <button class="read-more-btn"
                              *ngIf="data.recommendationEllipsisActive || data.isRecommendationExpanded"
                              (click)="toggleExpand(data, 'recommendation')">
                        {{ data.isRecommendationExpanded ? '[Collapse]' : '[More...]' }}
                      </button>
                    </div>
                  </td>
                </tr>
                
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="loading" class="loading-container">
  <app-ltms-loader></app-ltms-loader>
</div>